'use strict';
import "./utils/polyfill.js";
import Utils from "./utils/utils.js";
(function (w, d) {
    const callback = function () {
        setMenuBtn(),
        setPageScroll(),
        setPageScrollByUriHash(),
        setPagetopBtn();
        //Utils.displayPendhingNode();
    }
    if (d.readyState === "complete") {
        callback();
    } else {
        d.addEventListener("DOMContentLoaded", callback);
    }
    const setMenuBtn = () => {
        const hdrMenu = d.querySelector(".js-hdr-menu");
        if(hdrMenu != null){
            const bdy = d.querySelector("body"),
                hdr = d.querySelector(".js-hdr"),
                flg_open = "is-menu-open",
                flg_close = "is-menu-close";

            hdrMenu.addEventListener("click", function () {
                this.classList.toggle(flg_open),
                    this.classList.toggle(flg_close, !this.classList.contains(flg_open)),
                    bdy.classList.toggle(flg_open),
                    bdy.classList.toggle(flg_close, !bdy.classList.contains(flg_open)),
                    hdr.classList.toggle(flg_open),
                    hdr.classList.toggle(flg_close, !bdy.classList.contains(flg_open));
                this.classList.remove("is-init");

                return false;
            })
        }
    }
    const setPageScroll = () => {
        const triggers = d.querySelectorAll(".js-page-scroll");
        const scroll = function (ev) {
            const hash = this.getAttribute("href").substr(1);

            if (hash.length === 0) return false

            const target = d.getElementById(hash);

            if (!target) return false;

            const targetTop = target.getBoundingClientRect().top + w.pageYOffset,
                hdr = d.querySelector(".js-hdr");
            
            let targetPos = targetTop - (hdr.children[0].clientHeight);
            let pos = w.scrollY,
                duration = (targetPos - pos) / 20;
            const scrollToTarget = () => {
                if (targetPos > pos + duration) {
                    pos += duration;
                    targetPos = targetTop - (hdr.children[0].clientHeight);
                    scrollTo(0, pos);
                    w.requestAnimationFrame(scrollToTarget);
                } else {
                    scrollTo(0, targetPos);
                    w.cancelAnimationFrame(scrollToTarget);
                }
            }
            w.requestAnimationFrame(scrollToTarget);
            ev.preventDefault();
        }
        for (let i = triggers.length - 1; i >= 0; i--) {
            triggers[i].addEventListener("click", scroll);
        }
    }
    const setPageScrollByUriHash = () => {
        (function (ev) {
            const hash = w.location.hash.substr(1);

            if (hash.length === 0) return false

            const target = d.getElementById(hash);

            if (!target) return false;

            const targetTop = target.getBoundingClientRect().top + w.pageYOffset,
                hdr = d.querySelector(".js-hdr");
                  
            let targetPos = targetTop - (hdr.children[0].clientHeight);
            let pos = w.scrollY,
                duration = (targetPos - pos) / 20;
            const scrollToTarget = () => {
                if (targetPos <= pos + duration) {
                    pos -= duration;
                    targetPos = targetTop - (hdr.children[0].clientHeight);                    
                    scrollTo(0, pos);
                    w.requestAnimationFrame(scrollToTarget);
                } else {
                    scrollTo(0, targetPos);
                    w.cancelAnimationFrame(scrollToTarget);
                }
            }
            w.requestAnimationFrame(scrollToTarget);
        })()
    }
    
    const setPagetopBtn = () => {
        const ptBtn = d.querySelector(".js-pagetop");
        if( ptBtn != null ){
            w.addEventListener("scroll", function (ev) {
                if (this.scrollY > 10) {
                    ptBtn.classList.add("is-active");
                } else {
                    ptBtn.classList.remove("is-active");
                }
            });
            ptBtn.addEventListener("click", function (ev) {
                let pos = w.scrollY,
                    duration = -pos / 20;
                const scrollTop = () => {
                    if (0 < pos + duration) {
                        pos += duration;
                        scrollTo(0, pos);
                        w.requestAnimationFrame(scrollTop);
                    } else {
                        scrollTo(0, 0);
                        w.cancelAnimationFrame(scrollTop);
                    }
                }
                w.requestAnimationFrame(scrollTop);
                ev.preventDefault();
            })
        }
    }

    // PC question and answer
    d.querySelectorAll('.c-qaListItem').forEach((item) => {
        item.addEventListener('click', (obj) => {
            let elem = null;
            let tmp_elem = obj.target.parentNode;
            try {
                while( elem === null ) {
                    tmp_elem.classList.forEach((c_name)=>{
                        if(c_name == 'c-qaListItem'){
                            elem = tmp_elem;
                        } else {
                            tmp_elem = tmp_elem.parentNode;
                        }
                    });
                }
                
                if(elem.classList.contains('c-qaListItem--is_active')){
                    elem.classList.remove('c-qaListItem--is_active');
                } else {
                    elem.classList.add('c-qaListItem--is_active');
                }
            } catch (error) {
                console.error(error);
            }
        })
    });
})(window, document);

